import React, { useState } from 'react';
import { Database, FileText, ArrowRight, CheckCircle2, Loader2, Sparkles } from 'lucide-react';

export const MigrationObjectCatalog = ({ project }) => {
  const [generating, setGenerating] = useState(false);
  const [catalog, setCatalog] = useState(null);

  const generateCatalog = () => {
    setGenerating(true);
    setTimeout(() => {
      setCatalog({
        total_objects: 156,
        objects: [
          { ecc_object: 'MARA', s4_object: 'MARA', mapping_type: 'Direct', fields: 89, complexity: 'low', template_available: true },
          { ecc_object: 'BSEG', s4_object: 'ACDOCA', mapping_type: 'Transformation', fields: 245, complexity: 'high', template_available: true },
          { ecc_object: 'KNA1', s4_object: 'BUT000', mapping_type: 'Business Partner', fields: 156, complexity: 'high', template_available: true },
          { ecc_object: 'MKPF/MSEG', s4_object: 'MATDOC', mapping_type: 'Consolidation', fields: 178, complexity: 'medium', template_available: true }
        ]
      });
      setGenerating(false);
    }, 2000);
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-2">Migration Object Catalog (MOC)</h2>
            <p className="text-gray-600">ECC-S/4 object mapping catalog with load templates</p>
          </div>
          <button onClick={generateCatalog} disabled={generating} className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-6 py-3 rounded-xl hover:shadow-lg flex items-center space-x-2 disabled:opacity-50">
            {generating ? <><Loader2 className="w-5 h-5 animate-spin" /><span>Generating...</span></> : <><Sparkles className="w-5 h-5" /><span>Generate Catalog</span></>}
          </button>
        </div>
      </div>

      {catalog && (
        <>
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-6 text-white">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-2xl font-bold mb-2">Migration Objects Identified</h3>
                <p className="text-blue-100">Auto-generated mapping catalog</p>
              </div>
              <div className="text-5xl font-bold">{catalog.total_objects}</div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-md p-6">
            <h3 className="text-xl font-bold mb-6">Object Mappings</h3>
            <div className="space-y-3">
              {catalog.objects.map((obj, idx) => (
                <div key={idx} className="border-2 border-gray-200 rounded-lg p-5">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-4 flex-1">
                      <div className="bg-blue-100 px-4 py-2 rounded-lg min-w-[120px]">
                        <p className="text-xs text-blue-600">ECC</p>
                        <p className="text-sm font-bold text-blue-900">{obj.ecc_object}</p>
                      </div>
                      <ArrowRight className="w-6 h-6 text-gray-400" />
                      <div className="bg-purple-100 px-4 py-2 rounded-lg min-w-[120px]">
                        <p className="text-xs text-purple-600">S/4HANA</p>
                        <p className="text-sm font-bold text-purple-900">{obj.s4_object}</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <span className="px-3 py-1 bg-gray-100 rounded-full text-xs font-semibold">{obj.mapping_type}</span>
                      {obj.template_available && <CheckCircle2 className="w-5 h-5 text-green-600" />}
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div><span className="text-gray-600">Fields:</span> <span className="font-semibold">{obj.fields}</span></div>
                    <div><span className="text-gray-600">Complexity:</span> <span className={`font-semibold capitalize ${
                      obj.complexity === 'low' ? 'text-green-600' :
                      obj.complexity === 'medium' ? 'text-yellow-600' : 'text-red-600'
                    }`}>{obj.complexity}</span></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MigrationObjectCatalog;